import speed from 'shared/assets/icons/speed.svg'
import laptop from '../assets/laptop.svg'
import plan from '../assets/plan.svg'

export const features = [
  {
    icon: speed,
    title: 'Real-Time Processing',
    description: 'Ultra-low latency, scalable performance across multiple instances',
  },
  {
    icon: laptop,
    title: 'Cross-Platform Development',
    description: 'C++/NVIDIA CUDA/AMD HIP/APPLE Metal support across multiple GPU targets',
  },
  {
    icon: plan,
    title: 'Streamlined Integration',
    description: 'Standardized templates  and context objects simplify development',
  },
]
